import { createElement } from 'react';

interface WeaveTooltipProps extends React.HTMLAttributes<HTMLElement> {
	className?: string;
	text: string;
	image?: string;
	description?: string;
	link?: string;
	nub?:
		| 'up-left'
		| 'up-right'
		| 'up-center'
		| 'down-center'
		| 'down-left'
		| 'down-right'
		| 'left-center'
		| 'right-center';
	shortcutmac?: string;
	shortcutwin?: string;
	closedelay?: number;
	opendelay?: number;
	width?: string;
	splitshortcutonspace?: boolean;
	linktext?: string;
	offset?: string;
	show?: (e: React.MouseEvent) => void;
	defaultSlot?: React.ReactNode;
}

export function WeaveTooltip({
	className,
	text,
	image,
	description,
	link,
	nub,
	shortcutmac,
	shortcutwin,
	closedelay = 0,
	opendelay = 300,
	width,
	splitshortcutonspace,
	linktext,
	offset,
	show,
	defaultSlot,
	children,
}: WeaveTooltipProps) {
	return createElement(
		'weave-tooltip',
		{
			className,
			text,
			image,
			description,
			link,
			nub,
			shortcutmac,
			shortcutwin,
			closedelay,
			opendelay,
			width,
			splitshortcutonspace,
			linktext,
			offset,
			show,
			defaultSlot,
		},
		children
	);
}
